<template>
  <Modal class="max-w-[600px]!">
    <Modal.Title>Share technical comparison analysis report</Modal.Title>
    <Modal.Body>
      <ShareReportBody
        :report="report"
        :get-report="getReport"
        :public-url="publicUrl"
      />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import type { ReportQuery } from '@/shared/graphql/router/graphql'
import ShareReportBody from './ShareReportBody.vue'

type ShareReport = NonNullable<ReportQuery['report']>

defineProps<{
  report: ShareReport
  getReport?: () => ShareReport | undefined
  publicUrl?: string
}>()
</script>
